<template>
  <div class="result-list" v-if="items && items.length > 0">
    <h3>{{topic}}</h3>
    <ul class="list-item">
      <li v-for="(fund, index) in items.slice(0,page)" :key="index">
        <a
          data-action="open_fund"
          :data-listname="'search_'+searchTab"
          :data-fundname="fund.short_code"
          href="javascript:;"
          @click="clickItemStock(fund.id)"
        >
          <h4>{{ fund.short_code }}</h4>
          <p>{{ fund.name_th }}</p>
        </a>
      </li>
      <a
        data-action="open_search_fund"
        data-eventcategory="search_flow"
        href="javascript:;"
        v-if="viewAll == 'all'"
        @click="clickItemAll()"
        class="view-funds view-more"
      >
        ดูทั้งหมด
        <i class="fas fa-chevron-right"></i>
      </a>
    </ul>
    <infinite-loading v-if="viewAll != 'all'" spinner="waveDots" @infinite="infiniteHandler"></infinite-loading>
  </div>
</template>
<script>
import GlobalSearchHistory from "../../mixins/global-search-history.js";

export default {
  props: {
    topic: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => {
        return [];
      }
    },
    searchTab: {
      type: String,
      default: null
    },
    searchText: {
      type: String,
      default: null
    },
    defaultSize: {
      type: Number,
      default: 3
    },
    viewAll: {
      type: String,
      default: ""
    }
  },
  watch: {
    viewAll() {
      this.viewAll == "all" ? (this.page = this.defaultSize) : null;
    }
  },
  data() {
    return {
      page: this.defaultSize
    };
  },
  mixins: [GlobalSearchHistory],
  methods: {
    clickItemAll() {
      this.page = 3;
      this.$emit("update:viewAll", "funds");
    },
    clickItemStock(id) {
      this.mixins_global_search_history(this.searchText);
      this.$router.push({ name: "miniapp-fund-quote", query: { id: id } });
    },
    async infiniteHandler($state) {
      if (this.page <= this.items.length) {
        this.page += 3;
        setTimeout(() => {
          $state.loaded();
        }, 1000);
      } else {
        $state.complete();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.result-list {
  margin-bottom: 32px;
  h3 {
    @extend %font-size-m;
    margin: 0;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: $color-normal-text;
  }
  .list-item {
    list-style: none;
    margin: 8px 0;
    width: 100%;
    padding: 0px;
    border-radius: 8px;
    border: solid 1px $color-line-grey;
    background-color: $color-white;
    display: inline-block;
    li {
      pointer-events: none;
      position: relative;
      border-bottom: 1px solid $color-line-grey;
      &:after {
        position: absolute;
        right: 16px;
        top: 24px;
        content: "\f105";
        font-family: "Font Awesome 5 Pro";
        font-size: 16px;
        color: $color-light-grey-2;
      }
      a {
        pointer-events: auto;
        text-decoration: none;
        padding: 8px 16px;
        display: block;
        border-radius: 8px;
        @include finRippleBtn($color-white, $color-white, $color-light-grey-2);
        h4 {
          pointer-events: none;
          @extend %font-size-s;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: $color-normal-text;
          margin: 0;
        }
        p {
          pointer-events: none;
          @extend %font-size-ss;
          margin: 0;
          color: $color-secondary-text;
          white-space: nowrap;
          max-width: 250px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .view-funds {
      text-decoration: none;
      padding: 8px 16px;
      position: relative;
      display: block;
      width: 100%;
      text-align: center;
      font-weight: bold;
      color: $color-normal-text;
      @extend %font-size-ss;
    }
    .view-more {
      i {
        width: 7px;
        text-align: center;
        font-weight: bold;
        flex-direction: column;
        justify-content: center;
        font-size: 10px;
        color: $color-normal-text;
        left: 2px;
        z-index: 12;
      }
    }
  }
}
</style>